/* tslint:disable */
/* eslint-disable */
export enum ProcessorEnum {
  Fiserv = 'Fiserv',
  PayPal = 'PayPal'
}
